import { z } from 'zod';
/**
 * Payload shape for `GET /api/dashboard/top-revenue-locations`.
 *
 * Top 10 revenue-grossing locations in the caller's scope over
 * a configurable date range (7d default; 30d / 90d presets;
 * arbitrary ranges via ?from=&to=, echoed back as range:'custom').
 * Server-side cached per (tenant, range-or-custom-bounds) for 60s.
 *
 * `is_scoped` drives empty-state copy. Same rationale as the
 * Recent Sessions widget — a scoped caller with no qualifying
 * sessions shouldn't see "No revenue yet" copy that implies
 * tenant-wide emptiness.
 */
/** Preset selector for the ?range= query param. Custom ranges do
 *  NOT travel through this enum — they ride ?from=&to= and surface
 *  in the response as range:'custom'. */
export const TopRevenueRangeSchema = z.enum(['7d', '30d', '90d']);
export const TopRevenueLocationRowSchema = z.object({
    location_id: z.string(),
    location_name: z.string(),
    /** Total revenue in cents over the requested window. */
    revenue_cents: z.number().int().nonnegative(),
    /** Number of completed sessions contributing to the revenue. */
    session_count: z.number().int().nonnegative(),
});
export const TopRevenueLocationsResponseSchema = z.object({
    rows: z.array(TopRevenueLocationRowSchema),
    /** The preset the response covers, or 'custom' when the request
     *  carried ?from=&to= instead of a preset range. */
    range: z.enum([...TopRevenueRangeSchema.options, 'custom']),
    is_scoped: z.boolean(),
    generated_at: z.string(),
});
//# sourceMappingURL=dashboard-top-revenue-locations.js.map